// export const endpoint = 'https://localhost:8000/graphql'
export const endpointold = 'https://api.graph.cool/simple/v1/oitoapi'
export const endpoint = 'https://oitoapi.herokuapp.com/graphql'

// export const auth_admin = "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE1NjAxOTg4MDYsImNsaWVudElkIjoiY2p3cXUzMmVuMWQ0NjAxMzRuOGZkZTJ2NCJ9.3xooejb5NOhHNc5898kzepPkNhwISDQM2sDA2MFvW18"

export const websocket = "wss://subscriptions.us-west-2.graph.cool/v1/oitoapi"

export const tokensms = '9eaecc364c8f54e88377aee84517c2dd'

export const configaws = {
    bucketName: 'oitofileserver',
    dirName: '/avatar', /* optional */
    region: 'us-east-2',
    accessKeyId: 'AKIAIRQOY4YNAVZ2W75A',
    secretAccessKey: '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'
}